module.exports = __webpack_public_path__ + "static/img/4010.ff68be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4010.png
// module id = 717
// module chunks = 0 1 12